import { Component, OnInit } from '@angular/core';
import { SettingsService } from '../../../core/settings/settings.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CustomValidators } from 'ng2-validation';
import { Router } from '@angular/router';
import {AngularFireDatabase} from 'angularfire2/database';
import { AngularFireAuth } from 'angularfire2/auth';
import { ToastrService } from 'toastr-ng2';
@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

    valForm: FormGroup;
    constructor(public af: AngularFireAuth, public settings: SettingsService, fb: FormBuilder, public router:Router, public db: AngularFireDatabase, public toastr:ToastrService) //,public toastr: ToastrService
    {

        this.valForm = fb.group({
            'email': ['', Validators.compose([Validators.required, CustomValidators.email])],
            'password': ['', Validators.required]
        });

    }

    submitForm($ev, value: any) {
        $ev.preventDefault();
        for (let c in this.valForm.controls) {
            this.valForm.controls[c].markAsTouched();
        }
        if (this.valForm.valid) {
            console.log('Valid!');
            console.log(value);
             this.af.auth.signInWithEmailAndPassword(value.email, value.password).then((success) => {
                      this.db.object('/users/' + success.uid).subscribe(res=>{

                        if(res.role == "Admin"){
                         this.router.navigate(['home']) ;
                         localStorage.setItem('uid',success.uid)
                           this.toastr.success('Login Successfully!', 'Success!');

                        } else{
                           //this.toastr.error('Login Failed!', 'You are not an ADMIN!');
                        }
                      })
                        })
        }
    }

    ngOnInit() {

    }

}



// WEBPACK FOOTER //
// /Users/sooweeseng/Documents/Ionic Apps/FoonYew2_Backend_ok_version/webapp/src/app/routes/pages/login/login.component.ts